/**
 * 自动关闭倒计时初始值（秒）
 */
export const AUTO_CLOSE_COUNTDOWN_INITIAL_VALUE = 3;

/**
 * 问题修复成功后自动切换到下一个问题的延迟时间（毫秒）
 */
export const ISSUE_FIX_AUTO_SWITCH_DELAY = 2000;
